<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('fpaManage.permanent.fpaNo')" prop="fpaNo">
                  <!--FPA编号-->
                  <el-input v-model="queryCondition.fpaNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('fpaManage.permanent.fpaName')" prop="fpaName">
                  <!--FPA名称-->
                  <el-input v-model="queryCondition.fpaName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('fpaManage.permanent.agreementLife')" prop="agreementStartDate" class="flexBox">
                  <!--FPA有效期-->
                  <el-date-picker v-model="queryCondition.startDate" type="date" :placeholder="'Select Date'" value-format="yyyy-MM-dd" :picker-options="AgreementPickerOptionsStart" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="To" prop="agreementEndDate" class="flexBox">
                  <el-date-picker v-model="queryCondition.endDate" type="date" :placeholder="'Select Date'" value-format="yyyy-MM-dd" :picker-options="AgreementPickerOptionsEnd" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Supplier Code " prop="supplierCode">
                    <!--供应商编号-->
                    <el-input v-model="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Supplier Name" prop="supplierAbbreviation">
                    <!--供应商简称-->
                    <el-input v-model="queryCondition.supplierAbbreviation" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Creator" prop="createUser">
                    <!--创建人-->
                    <el-input v-model="queryCondition.createUser" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Status" prop="status">
                    <!--状态-->
                    <ic-select clearable table="TT_FPA" field="QUERY_STATUS" v-model="queryCondition.status" style="width:100%" :placeholder="$t('BC.sel')"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Category1" prop="category1">
                    <el-select v-model="queryCondition.category1" clearable @change="changeCategory1()" style="width:100%" :placeholder="$t('BC.sel')">
                      <el-option :key="index" v-for="(item,index) in category1List" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category2" prop="category2">
                    <!--Category2-->
                    <el-select v-model="queryCondition.category2" clearable style="width:100%" :placeholder="$t('BC.sel')">
                      <el-option :key="index" v-for="(item,index) in category2List" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('fpaManage.permanent.materialNo')" prop="materialNo">
                    <!--物料编号,支持多个8位码，用英文逗号隔开-->
                    <el-input type="textarea" :rows="2" :placeholder="$t('fpaManage.permanent.materialNoPlaceHolder')" @input="materialNoChange(queryCondition.materialNo)" v-model="queryCondition.materialNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col v-if="!isSupplier" :span="6">
                  <el-form-item :label="$t('fpaManage.permanent.sourceType')" prop="sourceType">
                    <!--创建部门-->
                    <ic-select clearable table="TT_FPA" field="SOURCE_TYPE" v-model="queryCondition.sourceType" style="width:100%" :placeholder="$t('BC.sel')"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData" type="primary">Search</el-button>
          <el-button size="mini" @click="restQueryFormThis" type="primary">Reset</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'Fold':'Unfold'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div v-if="toolButton">
      <div v-if="'fpaPermanent'===activeName">
        <el-button v-acl="FpaPermanentNew" size="mini" class="btn" type="primary" @click="fpaNew()">New</el-button>
        <el-button v-acl="FpaPermanentCopy" size="mini" class="btn" type="primary" @click="fpaCopy()">Copy</el-button>
        <el-button v-acl="FpaPermanentDelete" size="mini" class="btn" type="danger" @click="fpaDelete()">Delete</el-button>
        <el-button size="mini" class="btn" v-if="canDownload" type="primary" @click="fpaListDownload">Download FPA List</el-button>
        <el-button v-acl="FpaPermanentRevoke" size="mini" class="btn" type="primary" @click="withdraw">Revoke</el-button>
      </div>
      <el-button v-if="'fpaPqcn'===activeName&&canDownload" size="mini" type="primary" @click="fpaListDownload">Download Item List</el-button>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="fpaCa_Tab">
      <el-tab-pane :label="$t('fpaManage.permanent.fpaQuery')" name="fpaPermanent">
        <el-table :data="tableFpaList" ref="tableFpaList" border highlight-current-row max-height='540' @selection-change="handleSelectChange">
          <el-table-column align="center" type="selection" width="55">
          </el-table-column>
          <!--FPA编号-->
          <el-table-column show-overflow-tooltip prop="fpaNo" :label="$t('fpaManage.permanent.fpaNo')" width="120px">
            <template slot-scope="scope">
              <div class="a-link" @click="toDetail(scope.row.ttFpaId,'N')">{{scope.row.fpaNo}}</div>
            </template>
          </el-table-column>
          <!-- FPA名称-->
          <el-table-column show-overflow-tooltip prop="fpaName" :label="$t('fpaManage.permanent.fpaName')" max-width="20px"></el-table-column>
          <!--FPA有效期开始-->
          <el-table-column show-overflow-tooltip prop="agreementStartDate" :label="$t('fpaManage.permanent.agreementStartDate')" min-width="60px">
            <template slot-scope="scope">
              {{scope.row.agreementStartDate | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </el-table-column>
          <!--FPA有效期结束-->
          <el-table-column show-overflow-tooltip prop="agreementEndDate" :label="$t('fpaManage.permanent.agreementEndDate')" min-width="60px">
            <template slot-scope="scope">
              {{scope.row.agreementEndDate | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </el-table-column>
          <!--供应商简称-->
          <el-table-column show-overflow-tooltip prop="supplierAbbreviation" label="Supplier Name" min-width="50px"></el-table-column>
          <!--状态-->
          <el-table-column show-overflow-tooltip prop="queryStatus" label="Status" min-width="50px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="statusValue" :label="$t('fpaManage.permanent.logicStatus')" min-width="50px"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('fpaManage.permanent.qpcnQuery')" name="fpaPqcn">
        <el-table :data="tablePqcnList" ref="tablePqcnList" border highlight-current-row max-height='420'>
          <el-table-column show-overflow-tooltip prop="fpaNo" :label="$t('fpaManage.permanent.fpaNo')" width="120px">
            <template slot-scope="scope">
              <div class="a-link" @click="toDetail(scope.row.ttFpaId,'N')">{{scope.row.fpaNo}}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="facilityName" label="Supplier/Facility" min-width="120px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="localItem" label="Local Number" min-width="110px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="productDescription" :label="$t('fpaManage.permanent.ProductDescription')" min-width="150px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="currentPricePerUom" label="Current Price per SU (Exwork,excluding VAT)" width="135px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="newPricePerUom" label="New Price per SU (excluding VAT)" width="130px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="validFrom" label="Price Valid From(Date)" width="170px">
            <template slot-scope="scope">
              {{scope.row.validFrom | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="validTo" label="Price Valid To(Date)" width="150px">
            <template slot-scope="scope">
              {{scope.row.validTo | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="transportaionMethodValue" label="Delivery Type" width="100px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="isIssued" label="是否同步MDM">
            <template slot-scope="scope">{{scope.row.isIssued|ic('TT_FPA','IS_ISSUED')}}</template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import fpaPermanentApi from "@/api/fpa/fpaPermanent";
import { fileService } from "@/api/common/file-utils";
import store from '@/store/index'
import paginationMixin from '@/mixins/pagitionMixin';

export default {
  components: { IcSelect },
  name: "fpaPermanentList",
  mixins: [paginationMixin],
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      activeName: "fpaPermanent",
      queryCondition: {
        queryType: 'fpaPermanent',
        pageSize: 15,
        pageNum: 1,
        fpaNo: '',
        fpaName: '',
        startDate: '',
        endDate: '',
        supplierCode: '',
        supplierAbbreviation: '',
        createUser: '',
        status: '',
        category1: null,
        category2: null,
        materialNo: '',
        sourceType: null,
      },
      selectRow: [],
      tableFpaList: [],
      tablePqcnList: [],
      category1List: [],
      category2List: [],
      totalCount: null,
      canDownload: true,
      toolButton: true,
      isSupplier: false,
      AgreementPickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      AgreementPickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.startDate;;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    };
  },
  computed: {
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    fpaPermanentApi.fpaList(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        if (vm.activeName == 'fpaPermanent') {
          // 触发‘FPA编号’事件
          vm.tableFpaList = res.resultData;
        } else {
          // 触发‘物料编号’事件
          vm.tablePqcnList = res.resultData;
        }
        vm.totalCount = res.totalCount;
      })
    })
  },
  created() {
    this.activeName = 'fpaPermanent';
    this.getCategoryList();
    let ms_roles = localStorage.getItem("ms_roles");
    let supplierObj = localStorage.getItem("supplierObj");
    let ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
    if (supplierObj) {
      this.isSupplier = true;
    }
    // if (supplierObj && JSON.parse(supplierObj).department == 'NFC') {//新品供应商（NFC）不支持创建FPA Permanent
    //   this.toolButton = false//一行按钮都隐藏了
    // }
    //供应商不能下载
    if (supplierObj && ms_Permission.indexOf('FpaListDownload') !== -1) {
      this.canDownload = false;
    }
    // this.queryData(1);
  },
  methods: {
    materialNoChange(el) {
      console.log("🚀 ~ file: fpaPermanentList.vue:280 ~ materialNoChange ~ el:", el)
      if (el.indexOf('\n') !== -1) {
        this.queryCondition.materialNo = el.split('\n').join(',')
      }
      console.log('更改后的', this.queryCondition.materialNo)
    },
    withdraw() {
      let that = this;
      if (that.selectRow.length == 0) {
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseToWithdraw'))
        return false;
      }
      let rows = that.selectRow;
      let checkData = false;
      for (let index in rows) {
        let rowData = rows[index];
        if (['ssNew', 'suNew', 'approved'].indexOf(rowData.status) >= 0) {
          checkData = true;
        }
      }
      if (checkData) {
        this.$message.error(this.$t('fpaManage.permanent.checkWithdraw'))
        return false;
      } else {
        that.$confirm('Would you like to withdraw the selected record?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          customClass: 'colorBtn',
          cancelButtonClass: 'btn_custom_cancel',
          type: 'warning'
        }).then(() => {
          let ttFpaIdArr = rows.map(row => row.ttFpaId);
          fpaPermanentApi.fpaWithdraw(ttFpaIdArr).then((res) => {
            if (res.code == '200') {
              this.activeName = 'fpaPermanent';
              this.queryData();
              this.selectRow = [];
            } else {
              this.$message.error(this.$t(res.msg) || 'Operate error')
            }
          });
        })
      }
    },
    getCategoryList() {
      let ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
      let isLogistics = false
      if (ms_Permission.indexOf('FpaPermanentLmApproving') !== -1) {
        isLogistics = true
      }
      fpaPermanentApi.findCategory({ categoryLevel: 1 }, isLogistics).then((res) => {
        console.log('findCategory~~~res :', res);
        // if (ms_Permission.indexOf('FpaPermanentLmApproving') !== -1) {
        //   res.data.map((v, i) => {
        //     if (v.code == 'Logistic' || v.code == 'service') {
        //       this.category1List.push(v)
        //     }
        //   })
        // } else {

        // }
        this.category1List = res.data;
      });
      fpaPermanentApi.findCategory({ categoryLevel: 2 }, isLogistics).then((res) => {
        console.log('findCategory2~~~~~res :', res);
        this.category2List = res.data;
        // if (ms_Permission.indexOf('FpaPermanentLmApproving') !== -1) {
        //   res.data.map((v, i) => {
        //     if (v.code == 'Logistic' || v.code == 'service') {
        //       this.category2List.push(v)
        //     }
        //   })
        // } else {
        //   this.category2List = res.data;
        // }
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      let ms_Permission = JSON.parse(localStorage.getItem("ms_Permission"));
      let isLogistics = false
      if (ms_Permission.indexOf('FpaPermanentLmApproving') !== -1) {
        isLogistics = true
      }
      let pid;
      this.category1List.forEach(category1 => {
        if (this.queryCondition.category1 == category1.code) {
          pid = category1.tmCategoryId;
        }
      });
      this.queryCondition.category2 = null;
      this.category2List = []
      fpaPermanentApi.findCategory({ categoryLevel: 2, pid: pid }, isLogistics).then((res) => {
        // if (ms_Permission.indexOf('FpaPermanentLmApproving') !== -1 && this.queryCondition.category1 == 'service') {
        //   res.data.map((v, i) => {
        //     if (v.code == 'planning-service' || v.code == 'toy-service') {
        //       this.category2List.push(v)
        //     }
        //   })
        // } else {
        //   this.category2List = res.data;
        // }
        this.category2List = res.data;
      });
    },
    handleClick(tab, event) {
      if (tab.name == 'fpaPermanent') {
        // 触发‘FPA查询’事件
        this.queryCondition.queryType = 'fpaPermanent';
        this.activeName = 'fpaPermanent';
      } else if (tab.name == 'fpaPqcn') {
        console.log('444', tab.name);
        console.log('888', this.canDownload);
        // 触发‘物料查询’事件
        this.activeName = 'fpaPqcn';
        this.queryCondition.queryType = 'fpaPqcn';
        this.selectRow = [];
      }
      this.fpaList();
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      if (this.activeName == 'fpaPermanent') {
        // 触发‘FPA编号’事件
        this.queryCondition.queryType = 'fpaPermanent';
      } else {
        // 触发‘物料编号’事件
        this.queryCondition.queryType = 'fpaPqcn';
      }
      this.fpaList();
    },
    fpaList() {
      console.log('12123123', this.queryCondition.materialNo)
      fpaPermanentApi.fpaList(this.queryCondition).then(res => {
        if (this.activeName == 'fpaPermanent') {
          // 触发‘FPA编号’事件
          this.tableFpaList = res.resultData;
        } else {
          // 触发‘物料编号’事件
          this.tablePqcnList = res.resultData;
        }
        this.totalCount = res.totalCount;
      });
    },
    fpaListDownload() {
      let that = this;
      fpaPermanentApi.fpaListDownload(this.queryCondition).then(res => {
        if (that.activeName == 'fpaPermanent') {
          // 触发‘FPA编号’事件
          fileService.respToFile(res, 'FPA查询.xls');
        } else {
          // 触发‘物料编号’事件
          fileService.respToFile(res, 'FPA物料查询.xls');
        }
      });
    },
    //选择操作
    handleSelectChange: function (row) {
      this.selectRow = row;
    },
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        queryType: 'fpaPermanent',
        pageSize: 15,
        pageNum: 1,
        fpaNo: '',
        fpaName: '',
        startDate: '',
        endDate: '',
        supplierCode: '',
        supplierAbbreviation: '',
        createUser: '',
        status: '',
        category1: null,
        category2: null,
        materialNo: '',
        sourceType: null,
      }
      this.queryData();
    },
    fpaDelete() {
      let that = this;
      if (that.selectRow.length == 0) {
        //请选择需要删除的记录！
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseToDelete'))
        return false;
      }
      let rows = that.selectRow;
      let checkData = false;
      for (let index in rows) {
        let rowData = rows[index];
        if (rowData.status != 'ssNew' && rowData.status != 'suNew' && rowData.status != 'mdmNew' && rowData.status != 'reject' && rowData.status != 'lmNew') {
          checkData = true;
        }
      }
      if (checkData) {
        //仅新建/审批退回状态下数据可删除！
        this.$message.error(this.$t('fpaManage.permanent.checkDelete'))
        return false;
      } else {
        //您确定要删除所选记录吗？
        that.$confirm('Are you sure to delete these records?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          customClass: 'colorBtn',
          cancelButtonClass: 'btn_custom_cancel',
          type: 'warning'
        }).then(() => {
          let ttFpaIdArr = rows.map(row => row.ttFpaId);
          let statusArr = rows.map(row => row.status);

          let param = {
            ttFpaIdArr: ttFpaIdArr + '',
            statusArr: statusArr + '',
          }
          fpaPermanentApi.fpaDelete(param).then((res) => {
            if (res.code == '200') {
              this.activeName = 'fpaPermanent';
              this.queryData();
              this.selectRow = [];
            } else {
              this.$message.error(this.$t(res.msg) || 'Operate error')
            }
          });
        })

      }
    },
    fpaNew() {
      this.toDetail('-1', 'N');
    },
    fpaCopy() {
      if (this.selectRow.length == 0 || this.selectRow.length > 1) {
        //请选择一条记录进行复制！
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseToCopy'))
        return false;
      }
      let statusArr = this.selectRow.map(row => row.status);
      if (statusArr[0] != 'approved') {
        //只能选择审批通过的单据
        this.$message.error(this.$t('fpaManage.permanent.pleaseChooseApprovedToCopy'))
        return false;
      }

      let ttFpaIdArr = this.selectRow.map(row => row.ttFpaId);
      this.toDetail(ttFpaIdArr[0], 'Y');
    },
    toDetail(ttFpaId, isCopy) {
      this.$router.push({ name: 'fpaPermanentDetail', params: { ttFpaId: ttFpaId, isCopy: isCopy } });
    },
  },
  extends: commonFunction
};
</script>
<style scoped  lang="scss">
.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.supplierCodeDialog .email.el-form-item .el-form-item__content {
  display: flex;
}
</style>
